(ns manage.ad-variant-preview.widgets.component-error
  (:require ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [uix.core :as uix :refer [$ defui]]))

(defui component-error [{:keys [width height]}]
  ($ Stack
     {:justifyContent "center"
      :alignItems "center"
      :sx #js {:height height
               :width width
               :minWidth "100%"
               :backgroundColor "grey.70"}}
     ($ Typography
        {:fontSize "lg"
         :fontWeight "600"
         :textAlign "center"}
        "Preview unavailable")))